/**
 * API Configuration Utility
 * Dynamically determines the API base URL based on the current hostname
 * Uses HTTPS when page is loaded over HTTPS to avoid mixed content issues
 */

// Cache the API URL to avoid recalculating and logging repeatedly
let cachedApiUrl = null;
let hasLogged = false;

export const getApiBaseUrl = () => {
  // Return cached value if available
  if (cachedApiUrl !== null) {
    return cachedApiUrl;
  }

  // Prioritize runtime detection over build-time environment variables
  // This ensures it works correctly when moved between environments
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol; // 'https:' or 'http:'
    const isHttps = protocol === 'https:';
    
    // Production domain detection - use relative path for HTTPS (Nginx proxy)
    if (hostname === 'matrix.refadtech.com' || hostname === 'matrixprod.refadtech.com' || hostname === 'axera-sa.cloud' || hostname === '72.60.35.223') {
      // Use same protocol as the page (HTTPS in production) and relative path
      // Nginx will proxy /api to the backend
      const apiUrl = isHttps ? '/api' : `http://${hostname}:5001/api`;
      hasLogged = true;
      cachedApiUrl = apiUrl;
      return apiUrl;
    }

    // Dev subdomain - React dev server + Node API behind Nginx (same-origin /api)
    if (hostname === 'dev.matrix.refadtech.com' || hostname === 'dev.axera-sa.cloud') {
      const apiUrl = isHttps ? '/api' : `http://${hostname}:5001/api`;
      hasLogged = true;
      cachedApiUrl = apiUrl;
      return apiUrl;
    }
    
    // Localhost detection
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      hasLogged = true;
      cachedApiUrl = 'http://localhost:5001/api';
      return cachedApiUrl;
    }
  }
  
  // Fallback to environment variable if set (for build-time configuration)
  if (process.env.REACT_APP_API_URL) {
    hasLogged = true;
    cachedApiUrl = process.env.REACT_APP_API_URL;
    return cachedApiUrl;
  }
  
  hasLogged = true;
  cachedApiUrl = 'http://localhost:5001/api';
  return cachedApiUrl;
};

export const getApiBaseUrlWithoutApi = () => {
  // Prioritize runtime detection over build-time environment variables
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol; // 'https:' or 'http:'
    const isHttps = protocol === 'https:';
    
    // Production domain detection
    if (hostname === 'matrix.refadtech.com' || hostname === 'matrixprod.refadtech.com' || hostname === 'axera-sa.cloud' || hostname === '72.60.35.223') {
      // Use same protocol as the page (HTTPS in production)
      return isHttps ? '' : `http://${hostname}:5001`;
    }

    // Dev subdomain
    if (hostname === 'dev.matrix.refadtech.com' || hostname === 'dev.axera-sa.cloud') {
      return isHttps ? '' : `http://${hostname}:5001`;
    }
    
    // Localhost detection
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5001';
    }
  }
  
  // Fallback to environment variable if set (for build-time configuration)
  if (process.env.REACT_APP_API_URL) {
    // Remove /api if present
    return process.env.REACT_APP_API_URL.replace(/\/api$/, '');
  }
  
  // Default to localhost
  return 'http://localhost:5001';
};

